import React from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Typography from "@material-ui/core/Typography";
import { Trad } from "src/components";
import { _ButtonAPI } from "..";
import { GetFormattedValue } from "../../helpers/Common";

interface ISpecialAcceptanceDetailsProps {
    Data: any;
    ColSpan: number;
}

const useStyles = makeStyles(({ palette, spacing }: Theme) => ({
    expanded: {
        backgroundColor: palette.grey[50],
        border: "none",
        paddingLeft: spacing(2)
    }
}));

export const _SpecialAcceptanceDetails: React.FC<ISpecialAcceptanceDetailsProps> = ({ Data, ColSpan }) => {
    const classes = useStyles();

    return (
        <>
            <TableRow>
                <TableCell variant="head" colSpan={ColSpan} className={classes.expanded}>
                    <Typography variant="h6">{Trad.Trad("Dati deroga")}</Typography>
                </TableCell>
            </TableRow>
            {Object.keys(Data).map((key, index) => (
                <TableRow key={index} className={classes.expanded}>
                    <TableCell colSpan={2} className={classes.expanded}>
                        <Typography variant="body2">{Trad.Trad(key)}</Typography>
                    </TableCell>
                    <TableCell align="right" colSpan={1} className={classes.expanded}>
                        {GetFormattedValue(Data[key].Valore, Data[key].Tipo)}
                    </TableCell>
                    <TableCell colSpan={ColSpan - 3} className={classes.expanded} />
                </TableRow>
            ))}
        </>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/components/SpecialAcceptanceList/SpecialAcceptanceDetails.tsx